// src/store/store.ts

import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth_slice";
import signupReducer from "./signup_slice";
import droneReducer from "./drone_slice"; // Importăm reducer-ul pentru drone
import messageReducer from "./message_slice"; // Import the new reducer
import whatsAppReducer from "./whatsApp_slice"; // Import WhatsApp reducer

export const store = configureStore({
  reducer: {
    auth: authReducer,
    signup: signupReducer,
    drones: droneReducer,
    messages: messageReducer, // Add message reducer to the store
    whatsApp: whatsAppReducer, // Add WhatsApp reducer to the store
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
